import { TextShimmer } from "@/components/text-shimmer";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { selectSearchStatus } from "@/feature/flight/search/state/selectors";

import { cn } from "@/lib/utils";
import { useAppSelector } from "@/redux/hooks";

import React from "react";

type AccordionSectionProps = {
  value: string;
  label: string;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
};

const AccordionSection: React.FC<AccordionSectionProps> = ({
  value,
  label,
  children,
  className,
  disabled,
}) => {
  const { isResponseEnd, error } = useAppSelector(
    selectSearchStatus,
  );
  const isSectionDisabled = disabled ?? !isResponseEnd;

  return (
    <AccordionItem
      value={value}
      className={cn(" bg-background  ", className)}
      disabled={isSectionDisabled}
    >
      <AccordionTrigger className="hover:no-underline py-2.5 px-4 font-semibold ">
        <div className="flex items-center gap-2">
          {!isResponseEnd && !error ? (
            <TextShimmer duration={4}>{label}</TextShimmer>
          ) : (
            label
          )}
        </div>
      </AccordionTrigger>
      <AccordionContent className="space-y-4 pt-3 px-4 h-auto!">
        {children}
      </AccordionContent>
    </AccordionItem>
  );
};

export default AccordionSection;
